import { Component, computed } from '@angular/core';
import { BaseCellComponent } from '@adnova/jf-ng-components';

import { AnnouncementTableItem } from '../+definitions';

/**
 * Cell-Komponente für die Zielgruppe-Spalte in der Announcement-Tabelle.
 *
 * Zeigt die Organisationsnummern kommagetrennt an oder "Alle Nutzer",
 * wenn keine Organisationsreferenzen hinterlegt sind.
 *
 * @extends BaseCellComponent<AnnouncementTableItem>
 */
@Component({
  selector: 'app-zielgruppe-cell',
  standalone: true,
  templateUrl: './zielgruppe-cell.component.html',
})
export class ZielgruppeCellComponent extends BaseCellComponent<AnnouncementTableItem> {

  protected readonly zielgruppe$$ = computed(() => {
    const refs = this.data().organizationReferences;
    if (!refs?.length) return 'Alle Nutzer';
    return refs.map(r => r.reference).join(', ');
  });
}
